export default __webpack_public_path__ + "static/media/benefit_15.09c01d72.png";